module.exports = __webpack_public_path__ + "img/wz-7-1-5.1955e044.jpg";